module.exports = __webpack_public_path__ + "img/sub12.b90383b2.jpg";